import React from 'react';
import { Flex, Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { ReactComponent as ApplePayIcon } from '@assets/icons/apple-pay.svg';
import { ReactComponent as GooglePayIcon } from '@assets/icons/google-pay.svg';
import { ReactComponent as StripeLinkIcon } from '@assets/icons/stripe_link.svg';

/** Cash funds settled in GBP run through the UK Stripe account, which surfaces Link instead of Google Pay. */
const UK_CURRENCY_CODE = 'GBP';

type ExpressPayLogosProps = Readonly<{
  /**
   * ISO currency code of the cash fund / registry. `GBP` renders Apple Pay + Link (the UK express
   * methods); every other currency renders Apple Pay + Google Pay (the US/default set).
   */
  currencyCode?: string;
}>;

export const ExpressPayLogos: React.FC<ExpressPayLogosProps> = ({ currencyCode }) => {
  const isUK = currencyCode?.toUpperCase() === UK_CURRENCY_CODE;

  return (
    <Flex alignItems="center">
      <Box marginRight={pxToRem(5)}>
        <ApplePayIcon />
      </Box>
      <Box>{isUK ? <StripeLinkIcon /> : <GooglePayIcon />}</Box>
    </Flex>
  );
};
